import './Footer.scss'

export default function Footer() {
  return (
    <div className="footer">
      ©Yokozuna Data, all rights reserved.
    </div>
  )
}
